import { createContext, useContext, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { tokenStore, useGet } from "./api";
import { applyTheme } from "./theme";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const qc = useQueryClient();
  const has = !!tokenStore.get();
  const q = useGet(has ? "/auth/me" : null, { interval: 10000 });
  const me = q.data;
  useEffect(() => {
    if (me) applyTheme(me.theme, me.font);
  }, [me]);
  const logout = () => {
    tokenStore.clear();
    qc.clear();
    window.location.replace("/");
  };
  const names = me ? { [me.id]: me.display_name, [me.partner]: me.partner_name } : {};
  return <Ctx.Provider value={{ me, loading: has && q.isLoading, logout, names }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
export const useName = () => {
  const { names } = useAuth();
  return (u) => (u === "both" ? "Both" : names[u] || (u ? u[0].toUpperCase() + u.slice(1) : "—"));
};
